import step1img from '../../../../assets/images/return/step1.png';
import { useTranslate } from '../../../../hooks/useTranslate';

import {
  ContentWrapper,
  Heading,
  Image,
  ListItem,
  OrderedList,
} from '../../styled';
import { AttentionBlock, AttentionIcon, AttentionText } from './styled';

export default function ReturnPolicy(): JSX.Element {
  const { staticTranslate } = useTranslate();

  return (
    <>
      <Image src={step1img} />
      <ContentWrapper>
        <Heading>{staticTranslate('ReturnPolicyTerminalX')}</Heading>
        <OrderedList>
          <ListItem>{staticTranslate('YouMusthavePurchasedThe')}</ListItem>
          <ListItem>{staticTranslate('LessThan14DaysMustHave')}</ListItem>
          <ListItem>{staticTranslate('AReturnFormMustBeAttached')}</ListItem>
        </OrderedList>
        <AttentionBlock>
          <AttentionIcon />
          <AttentionText>
            {`${staticTranslate('DamagedGoods')} ${staticTranslate(
              'WillNotBeAcceptedForReturn',
            )}`}
          </AttentionText>
        </AttentionBlock>
      </ContentWrapper>
    </>
  );
}
